import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInsightAwareness = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32.05 28.6667",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M23.9999 17L30.6665 15.6667L23.9999 25L15.9999 27.6667L7.99987 25L1.3332 15.6667L7.99987 17M15.9999 27.6667L13.3332 14.3333M15.9999 27.6667L18.6665 14.3333M15.9999 27.6667L7.99987 17M15.9999 27.6667L23.9999 17M7.99987 17L6.66653 9L13.3332 14.3333M13.3332 14.3333L15.9999 1L18.6665 14.3333M18.6665 14.3333L25.3332 9L23.9999 17M1 9.33333H1.05M31 9.33333H31.05",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgInsightAwareness;
